import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	defaultValueTooLongErrorText: {
		id: 'project-settings-apps.issue-type-page.field-associated.field-configuration.text.default-value-too-long-error-text',
		defaultMessage: "Text fields can't have more than {MAX_ALLOWED_TEXT_LENGTH} characters.",
		description: 'Validation error shown to the user if too long text is typed in the input.',
	},
});
